import { LayoutDashboard, Users, Pill, Package, Warehouse } from 'lucide-react';

const DesktopSidebar = ({ activeTab, dispatch, queueCount, pendingOrders }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'customers', label: 'Customers', icon: Users },
    { id: 'dispensing', label: 'Dispensing', icon: Pill, badge: queueCount },
    { id: 'orders', label: 'Orders', icon: Package, badge: pendingOrders },
    { id: 'inventory', label: 'Inventory', icon: Warehouse },
  ];

  return (
    <aside className="hidden lg:flex flex-col w-56 min-h-[calc(100vh-60px)] sticky top-[60px] p-3 bg-gradient-to-b from-white/90 via-slate-50/80 to-indigo-50/40 backdrop-blur-xl border-r border-gray-200/50">
      {/* Decorative gradient orb */}
      <div className="absolute top-20 -left-10 w-32 h-32 bg-brand-400/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 -left-5 w-24 h-24 bg-accent-400/10 rounded-full blur-2xl pointer-events-none" />

      <nav className="flex-1 space-y-1 mt-2 relative z-10">
        {menuItems.map(item => {
          const isActive = activeTab === item.id || (item.id === 'customers' && activeTab === 'customer-detail');
          return (
            <button
              key={item.id}
              onClick={() => dispatch({ type: 'SET_ACTIVE_TAB', payload: item.id })}
              className={`flex items-center w-full px-3 py-2.5 rounded-xl transition-all duration-200 group relative ${
                isActive
                  ? 'bg-gradient-to-r from-brand-500 to-brand-600 text-white shadow-brand'
                  : 'text-gray-600 hover:bg-white/70 hover:text-gray-900 hover:shadow-sm'
              }`}
            >
              {isActive && (
                <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-1.5 h-8 bg-brand-500 rounded-r-full" />
              )}
              <item.icon className={`h-5 w-5 mr-3 transition-transform duration-200 ${
                isActive ? '' : 'group-hover:scale-110'
              }`} />
              <span className="font-medium text-sm flex-1 text-left">{item.label}</span>
              {item.badge > 0 && (
                <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${
                  isActive
                    ? 'bg-white/20 text-white'
                    : 'bg-red-100 text-red-700'
                }`}>
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

    </aside>
  );
};

export default DesktopSidebar;
